module.exports = __webpack_public_path__ + "static/media/log.c137c688.png";